import React, { useState, useEffect } from "react";
export default function Products() {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ name: "", hsn: "", price: "", tax_rate: "18" });

  const loadData = () => fetch('/api/products').then(r=>r.json()).then(d=>setData(Array.isArray(d)?d:[]));
  useEffect(() => { loadData(); }, []);

  const save = async (e) => {
    e.preventDefault();
    const url = editId ? `/api/products/${editId}` : '/api/products';
    const method = editId ? 'PUT' : 'POST';
    await fetch(url, { method, headers: {'Content-Type':'application/json'}, body: JSON.stringify({...form, price: Number(form.price), tax_rate: Number(form.tax_rate)}) });
    setShow(false); setEditId(null); loadData(); 
    setForm({ name: "", hsn: "", price: "", tax_rate: "18" });
  };

  const handleEdit = (p) => {
    setForm({ name: p.name||"", hsn: p.hsn||"", price: p.price||"", tax_rate: p.tax_rate||"18" });
    setEditId(p.id);
    setShow(true);
  };

  const handleDelete = async (id) => {
    if(window.confirm("Kya aap is service/product ko sach mein delete karna chahte hain?")) {
       await fetch(`/api/products/${id}`, { method: 'DELETE' });
       loadData();
    }
  };

  const cancelEdit = () => {
    setShow(false); setEditId(null);
    setForm({ name: "", hsn: "", price: "", tax_rate: "18" });
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex justify-between mb-4">
         <h1 className="text-2xl font-bold">Services / Products</h1>
         <button onClick={()=>{setShow(true); setEditId(null); setForm({ name: "", hsn: "", price: "", tax_rate: "18" });}} className="bg-purple-600 text-white px-4 py-2 rounded shadow">+ Add Service</button>
      </div>
      {show && (
        <form onSubmit={save} className="bg-white p-4 shadow mb-4 grid grid-cols-4 gap-4 rounded relative">
          <button type="button" onClick={cancelEdit} className="absolute top-2 right-4 text-red-500 font-bold hover:underline">✕ Close</button>
          <input placeholder="Service Name (e.g. IVR)" required className="border p-2 mt-4" value={form.name} onChange={e=>setForm({...form, name:e.target.value})} />
          <input placeholder="HSN/SAC Code (Optional)" className="border p-2 mt-4" value={form.hsn} onChange={e=>setForm({...form, hsn:e.target.value})} />
          <input type="number" placeholder="Base Rate (₹)" required className="border p-2 mt-4" value={form.price} onChange={e=>setForm({...form, price:e.target.value})} />
          <input type="number" placeholder="GST % (e.g. 18)" required className="border p-2 mt-4" value={form.tax_rate} onChange={e=>setForm({...form, tax_rate:e.target.value})} />
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded col-span-4 font-bold">{editId ? "Update Service" : "Save Service"}</button>
        </form>
      )}
      <div className="bg-white shadow p-4 rounded overflow-x-auto">
        <table className="min-w-full text-left">
          <thead>
            <tr className="border-b text-gray-500 uppercase text-sm">
              <th className="pb-2">Name</th><th className="pb-2">HSN/SAC</th><th className="pb-2">Base Rate</th><th className="pb-2">GST %</th><th className="pb-2">Tax Amt</th><th className="pb-2">Total (₹)</th><th className="pb-2 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((p,i)=>{
              const base = Number(p.price || 0);
              const tax_rate = Number(p.tax_rate || 18);
              const tax_amt = base * (tax_rate / 100);
              const total = base + tax_amt;
              return (
                <tr key={i} className="border-b hover:bg-gray-50">
                  <td className="py-3 font-medium">{p.name}</td><td>{p.hsn || "-"}</td><td>₹{base.toFixed(2)}</td><td>{tax_rate}%</td><td className="text-red-500 font-medium">+ ₹{tax_amt.toFixed(2)}</td><td className="font-bold text-green-700 text-lg">₹{total.toFixed(2)}</td>
                  <td className="text-right whitespace-nowrap">
                    <button onClick={()=>handleEdit(p)} className="text-blue-600 font-bold mr-4 hover:underline">Edit</button>
                    <button onClick={()=>handleDelete(p.id)} className="text-red-600 font-bold hover:underline">Delete</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
